var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import { Dependencies } from "~/core/decorator";
import { Emit } from "vue-property-decorator";
import DataForm from "~/components/common/data-form.vue";
import DataBox from "~/components/common/data-box.vue";
import { CaseRepaymentService } from "~/services/domain-service/case-repayment.service";
var TeamCaseBatchRepayment = /** @class */ (function (_super) {
    __extends(TeamCaseBatchRepayment, _super);
    function TeamCaseBatchRepayment() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = {
            state: false
        };
        _this.selectCaseList = [];
        return _this;
    }
    TeamCaseBatchRepayment.prototype.close = function () { };
    /**
     * 反显数据
     */
    TeamCaseBatchRepayment.prototype.updateList = function (data) {
        // if (!data.id) return;
        this.selectCaseList = data.map(function (v) {
            return {
                id: v.id,
                caseNumber: v.caseNumber,
                personalName: v.personalName,
                overdueAmount: v.overdueAmount,
                repaymentAmount: 0
            };
        });
    };
    /**
     * 删除按钮
     */
    TeamCaseBatchRepayment.prototype.deleteClick = function (index, rows) {
        rows.splice(index, 1);
    };
    TeamCaseBatchRepayment.prototype.inputMax = function (scope) {
        if (scope.row.repaymentAmount > scope.row.overdueAmount) {
            scope.row.repaymentAmount = scope.row.overdueAmount;
        }
        if (scope.row.repaymentAmount < 0 || scope.row.repaymentAmount === '') {
            scope.row.repaymentAmount = 0;
        }
    };
    /**
     * 确定按钮
     */
    TeamCaseBatchRepayment.prototype.ConfirmBtn = function () {
        var _this = this;
        if (this.selectCaseList.find(function (v) { return v.repaymentAmount === 0; })) {
            this.$message('还款金额必须大于0');
            return;
        }
        var modelData = this.selectCaseList.map(function (v) {
            return {
                caseId: v.id,
                repayAmount: v.repaymentAmount
            };
        });
        this.caseRepaymentService
            .addCaseRepaymentBatch(modelData)
            .subscribe(function (data) {
            _this.$message.success("批量还款成功");
            _this.close();
        });
    };
    __decorate([
        Dependencies(CaseRepaymentService)
    ], TeamCaseBatchRepayment.prototype, "caseRepaymentService", void 0);
    __decorate([
        Emit("close")
    ], TeamCaseBatchRepayment.prototype, "close", null);
    TeamCaseBatchRepayment = __decorate([
        Component({
            components: {
                DataForm: DataForm,
                DataBox: DataBox
            }
        })
    ], TeamCaseBatchRepayment);
    return TeamCaseBatchRepayment;
}(Vue));
export default TeamCaseBatchRepayment;
